import type { IconData } from '@stacksjs/iconify-core'

export const spotifySolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 46.5C11.574 46.5 1.5 36.426 1.5 24S11.574 1.5 24 1.5S46.5 11.574 46.5 24S36.426 46.5 24 46.5m1.636-33.378c-4.475-.415-9.231.219-13.447 2.088a2 2 0 1 0 1.622 3.656c3.522-1.561 7.582-2.12 11.456-1.761c3.897.36 7.657 1.657 10.514 3.854a2 2 0 0 0 2.438-3.17c-3.572-2.748-8.094-4.252-12.583-4.667m-12.17 9.976c3.476-1.646 7.428-2.205 11.132-1.856c3.622.342 7.284 1.581 10.18 3.863a2 2 0 1 1-2.475 3.142c-2.177-1.715-5.066-2.738-8.081-3.023c-3.074-.29-6.292.186-9.044 1.49a2 2 0 1 1-1.712-3.616m10.097 6.31c-2.734-.266-5.652.142-8.247 1.36a2 2 0 1 0 1.7 3.62c1.876-.88 4.063-1.203 6.16-.999c2.113.206 4.116.945 5.61 2.16a2 2 0 0 0 2.525-3.101c-2.213-1.802-5.004-2.773-7.749-3.04\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default spotifySolid
